import origin from "axios";
import {
  BASEURL,
  DATEFILTER,
  GETALLOFFICES,
  GETALLSUBYOJNA,
  GETALLTALUKA,
  GETCHARTDATA,
  GETFORMFIELDS,
  GETFORMFIELDSWITHTALUKA,
  GETVISITRECORDS,
  ISVALIDUSER,
  LOGIN,
  TABLEINPUTVALUES,
  TAKRARPRANALI,
  TAKRARPRANALIDATA,
  TAKRARPRANALISTATUS,
  TAKRARPRANALIUPDATE,
  VISITRECORD,
} from "./api";

// Create a base axios instance
export const axios = origin.create({
  baseURL: BASEURL,
  headers: {
    "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
});

// Add a request interceptor to attach the token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('accessToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Define API methods
export const userLogin = async (formValues) => {
  try {
    const res = await axios.post(`${LOGIN}`, formValues, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const validUser = async (formValues) => {
  try {
    const res = await axios.post(`${ISVALIDUSER}`, formValues, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getAllTaluka = async () => {
  try {
    const res = await axios.get(`${GETALLTALUKA}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getAllSubyojna = async () => {
  try {
    const res = await axios.get(`${GETALLSUBYOJNA}`);
    return res;
  } catch (error) {
    throw error;
  }
};


export const getFormFieldsWithTaluka = async (id, subyojnaId) => {
  try {
    const res = await axios.get(`${GETFORMFIELDSWITHTALUKA}/${id}/${subyojnaId}`);
    return res;
  } catch (error) {
    throw error;
  }
};


export const getFormFields = async (subyojnaId) => {
  try {
    const res = await axios.get(`${GETFORMFIELDS}/${subyojnaId}`);
    return res;
  } catch (error) {
    throw error;
  }
};


export const getVisitRecord = async (talukaId) => {
  try {
    const res = await axios.get(`${GETVISITRECORDS}/${talukaId}`);
    return res;
  } catch (error) {
    throw error;
  }
};


export const getChartData = async () => {
  try {
    const res = await axios.get(`${GETCHARTDATA}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const dateFilter = async (formValues) => {
  try {
    const res = await axios.post(`${DATEFILTER}`, formValues, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};



export const visitRecord = async (formValues) => {
  try {
    const res = await axios.post(`${VISITRECORD}`, formValues, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const tableInputValues = async (formValues) => {
  try {
    const res = await axios.post(`${TABLEINPUTVALUES}`, formValues, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const takrarPranaliForm = async (formData) => {
  try {
    const res = await axios.post(`${TAKRARPRANALI}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const takrarPranaliData = async () => {
  try {
    const res = await axios.get(`${TAKRARPRANALIDATA}`);
    return res;
  } catch (error) {
    throw error;
  }
};


export const takrarPranaliStatus = async (id) => {
  try {
    const res = await axios.get(`${TAKRARPRANALISTATUS}/${id}`);
    return res;
  } catch (error) {
    throw error;
  }
};


export const takrarPranaliUpdate = async (formData, getId) => {
  try {
    const res = await axios.post(`${TAKRARPRANALIUPDATE}/${getId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getAllOffices = async () => {
  try {
    const res = await axios.get(`${GETALLOFFICES}`);
    console.log(res, 'resreser')
    return res;
  } catch (error) {
    throw error;
  }
};